module.exports = __webpack_public_path__ + "img/vr_img.20cbc6c8.png";